const STRICT_DECIMAL_PATTERN = /^-?\d+([.,]\d+)?$/

// Returns a finite number, or null for empty / malformed values (e.g. "1abc", "100.").
// Unlike parseFloat, partial numeric prefixes are rejected.
const parseStrictDecimal = value => {
  if (value === '' || value === null || value === undefined) return null
  if (typeof value === 'number') return Number.isFinite(value) ? value : null

  const normalized = String(value).trim()
  if (!STRICT_DECIMAL_PATTERN.test(normalized)) return null

  const number = Number(normalized.replace(',', '.'))
  return Number.isFinite(number) ? number : null
}

const externalRules = {
  required: (value, message = 'Wymagane') => {
    if (value && value instanceof Array && value.length === 0) {
      return 'Wymagane'
    }
    if (typeof value === 'boolean') return true // without this line, value is invalid when 'false'
    return typeof value === 'number' ? true : !!value || message
  },
  postCode: value => {
    if (!value) return true
    return /^\d{2}-\d{3}$/.test(value) || 'Niepoprawny Kod pocztowy'
  },
  email: value => {
    if (!value) return true
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'Niepoprawny e-mail'
  },
  password: value => {
    if (!value) return true
    const pattern = /^.{6,}$/
    return pattern.test(value) || 'Hasło musi składać się z co najmniej 6 znaków'
  },
  notPastDate(value) {
    if (!value) return true
    const parsedValue = value
      .split('/')
      .reverse()
      .join('-') // value is in 'dd/mm/yyyy' format
    return parsedValue >= new Date().toISOString().substring(0, 10) || 'Podano przeszłą datę'
  },
  addressNumber: value => {
    if (!value) return true
    return /[\d]{1}/.test(value) || 'Podaj numer lokalu'
  },
  phoneNumber: value => {
    if (!value) return true
    return /^\d{3}-\d{3}-\d{3}$/.test(value) || 'Niepoprawny numer telefonu'
  },
  nipNumber: value => {
    if (!value) return true
    return /^\d{10}$/.test(value) || 'Nieprawidłowy numer NIP'
  },
  peselNumber: value => {
    if (!value) return true
    return /^\d{11}$/.test(value) || 'Nieprawidłowy numer PESEL'
  },
  bankAccount: value => {
    if (!value) return true
    return /^\d{2}[ ]\d{4}[ ]\d{4}[ ]\d{4}[ ]\d{4}[ ]\d{4}[ ]\d{4}/.test(value) || 'Nieprawidłowy numer konta'
  },
  number: value => {
    if (!value) return true
    return /^-?\d+([.,]{1}\d+)?$/.test(value) || 'Podaj liczbę'
  },
  integer: value => {
    if (!value) return true
    return /^\d+?$/.test(value) || 'Podaj liczbę całkowitą'
  },
  money: value => {
    if (!value) return true
    return /^\d+([.,]{1}\d{1,2})?$/.test(value) || 'Wprowadź poprawny format ( np. 1.23 )'
  },
  word: value => {
    if (!value) return true
    return /^\p{L}+$/gu.test(value) || 'Dozwolone są jedynie litery'
  },
  noSpaces: value => {
    return /^\S*$/.test(value) || 'Spacje nie są dozwolone'
  },
  debrisCode: value => {
    return /^[0-9 ]+/.test(value) || 'Przykładowy kod: "04 07 09*"'
  },

  match: match => value => value === match || 'Podane hasła różnią się',

  // those below must be pass as an object. E.g. {name: 'lowerThan', arg: 10}
  lowerThan: amount => value => {
    const number = parseStrictDecimal(value)
    if (number === null) return true
    return number < amount || `Zbyt wysoka wartość (Maks. ${amount - 1})`
  },

  lowerOrEqualThan: amount => value => {
    const number = parseStrictDecimal(value)
    if (number === null) return true
    return number <= amount || `Zbyt wysoka wartość (Maks. ${amount})`
  },

  greaterThan: amount => value => {
    const number = parseStrictDecimal(value)
    if (number === null) return true
    return number > amount || `Zbyt niska wartość (Min. ${amount + 1})`
  },

  maxLength: max => (value = '') => value.length <= max || `Maksymalna liczba znaków: ${max}`,

  minLength: max => (value = '') => value.length >= max || `Minimalna liczba znaków: ${max}`,

  objectEmpty: obj => Object.keys(obj).length !== 0 || 'Wymagane'
}

export default externalRules
